// extracted by mini-css-extract-plugin
var _1 = "f9ab9b";
var _2 = "c39598";
var _3 = "d9b0ab";
var _4 = "c82f2f";
var _5 = "da10e0";
export { _1 as "loading-spinner", _2 as "show-spinner-animation", _3 as "spinner_image", _4 as "spinner_wrapper", _5 as "spinner_wrapper__static" }
